import { Card, Stack, Typography } from '@mui/material';
import { ROUTES } from '@/constants/routes';
import { SVLink } from '../core';
import { CustomerDetails } from '@/types/customers';

type CustomerDetailsViewProps = {
  customerDetails: CustomerDetails;
};

export default function CustomerDetailsView({
  customerDetails,
}: CustomerDetailsViewProps) {
  const { uuid, aggregateInfo } = customerDetails;

  return (
    <Card variant="fullHeight">
      <Typography variant="h5" mb={2}>
        View
      </Typography>
      <Stack spacing={2}>
        <SVLink
          to={`${ROUTES.BANK_ACCOUNT_APPLICATIONS}/draft?consumer_id=${uuid}`}>
          Draft Bank Applications ({aggregateInfo.totalDraftBankApplications})
        </SVLink>
        <SVLink to={`${ROUTES.BANK_ACCOUNTS}?consumer_id=${uuid}`}>
          Active Bank Accounts ({aggregateInfo.totalActiveBankAccounts})
        </SVLink>
        <SVLink to={`${ROUTES.BUSINESSES}?consumer_id=${uuid}`}>
          Associated Businesses
        </SVLink>
        <SVLink to={`${ROUTES.CUSTOMERS}/${uuid}/external-accounts`}>
          External Accounts
        </SVLink>
        <SVLink to={`${ROUTES.CUSTOMERS}/${uuid}${ROUTES.WIRE_RECIPIENTS}`}>
          Wire Recipients
        </SVLink>
        <SVLink to={`${ROUTES.LENDING}?consumer_id=${uuid}`}>
          Lending Quote Requests
        </SVLink>
      </Stack>
    </Card>
  );
}
